export const NEW_DATASET = 'NEW_DATASET'
export const NEW_DATE_RANGE = 'NEW_DATE_RANGE'
export const NEW_FILTERED_SAMPLE_ID = 'NEW_FILTERED_SAMPLE_ID'
export const NEW_FILTERED_ENTRY_ID = 'NEW_FILTERED_ENTRY_ID'
export const CLICKED_ELEMENT = 'CLICKED_ELEMENT'
export const SELECTED_DATA = 'SELECTED_DATA'
export const TRANS_LINK_THRESHOLD = 'TRANS_LINK_THRESHOLD'
export const ACTIVE_CHART = 'ACTIVE_CHART'
export const INACTIVE_CHART = 'ACTIVE_CHART'
export const NEW_METADATA = 'NEW_METADATA'
export const NEW_FLOORPLAN = 'NEW_FLOORPLAN'
export const NEW_LAYOUT = 'NEW_LAYOUT'
export const NEW_FLOORPLAN_LEVEL = 'NEW_FLOORPLAN_LEVEL'
export const NEW_TREE = 'NEW_TREE'
export const NEW_TRANSMISSION = 'NEW_TRANSMISSION'
export const ADD_FLOORPLAN = 'ADD_FLOORPLAN'
export const NEW_TREE_ZOOM_LEVEL = 'NEW_TREE_ZOOM_LEVEL'
export const NEW_COLOR_INDEX = 'NEW_COLOR_INDEX'
export const NEW_SESSION = 'NEW_SESSION'



export const SHOWCASE_DATASET_1 = {metadataURL: './data/1/metadata1.csv',
                                    transmissionURL: undefined,
                                    floorplanURL: undefined,
                                    treeURL: undefined}


export const SHOWCASE_DATASET_2 = {metadataURL: './data/1/metadata1.csv',
                                transmissionURL: './data/1/transmission1.gv',
                                floorplanURL: './data/1/map1.geojson',
                                treeURL: './data/1/tree1.nwk'}

export const SHOWCASE_DATASET_3 = {metadataURL: './data/1/metadata1.csv',
                                floorplanURL: './data/1/map1.geojson'}

export const SHOWCASE_DATASET_4 = {metadataURL: './data/1/metadata1.csv',
                                transmissionURL: './data/1/trans1.csv',
                                floorplanURL: './data/1/map1.geojson',
                                treeURL: './data/1/tree1.nwk'}

//transmissionURL: './data/4/trans.csv',
//treeURL: './data/4/tree.nwk'}



// WEBPACK FOOTER //
// ./src/utils/constants.js